import Typography from '@eduzz/houston-ui/Typography';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React, { memo } from 'react';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  productId: number | string;
  copiedCheckout: () => void;
  className?: string;
}

const ShareableLinks = ({ productId, copiedCheckout }: IProps) => {
  return (
    <>
      <>
        <Typography size='xs' className='share-link-title'>
          Novo Checkout Sun
        </Typography>
        <CustomCopyToClipboard
            text={`${CHECKOUT_ELEMENTS_URL}/${productId}`}
            disableUnderline
            style={{ width: '100%', marginBottom: '0.5rem' }}
            onCopy={copiedCheckout}
        />
      </>
      <Typography size='xs' className='share-link-title'>
        Checkout Sun
      </Typography>
      <CustomCopyToClipboard text={`${CHECKOUT_SUN_URL}/${productId}`} disableUnderline fullWidth style={{ width: '100%' }} onCopy={copiedCheckout} />
    </>
  );
};

export default memo(ShareableLinks);
